<template>
  <div>
    <h1>Departments</h1>
    <v-btn :to="{name:'departmentAdd'}">
      <v-icon>add</v-icon>Department
    </v-btn>
    <v-data-table :headers="headers" :items="departments" hide-actions class="elevation-1">
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'department', params:{id:props.item.id}}" small>{{props.item.id}}</v-btn>
          </td>
          <td>{{props.item.name}}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Departments",
  metaInfo() {
    return {
      title: "Departments",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      departments: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        }
      ]
    };
  },
  methods: {
    fetchDepartments() {
      nbmlaw.get(`/cors/admin/file/departments`).then(response => {
        // console.log(response.data);
        this.departments = response.data;
      });
    }
  },
  created() {
    this.fetchDepartments();
  }
};
</script>